import { defineMessages } from 'react-intl';

export const LEGEND_MESSAGES = defineMessages({
  legendHideSeries: {
    id: 'XPLMI3aOe8TwFwJc',
    defaultMessage: 'Hide',
    description:
      'Text in a tooltip shown when hovering a legend series to hide it',
  },
  legendShowSeries: {
    id: '1e3uPo8SoI4NA2dZ',
    defaultMessage: 'Show',
    description:
      'Text in a tooltip shown when hovering a legend series to show it',
  },
  legendHideSeriesAria: {
    id: 'Vt7aUQHkFaDCuIqZ',
    defaultMessage: 'Hide {seriesName}',
    description:
      'Accessible label for the hide-series toggle button in a legend item',
  },
  legendShowSeriesAria: {
    id: 'k+a+zH/n3HXJex9e',
    defaultMessage: 'Show {seriesName}',
    description:
      'Accessible label for the show-series toggle button in a legend item',
  },
  legendSeriesActionsAria: {
    id: '3QeEQ2KrbnVJzUEp',
    defaultMessage: 'Open actions for {seriesName}',
    description:
      'Accessible label for the series actions menu button in a legend item',
  },
  legendSeriesHiddenAnnouncement: {
    id: 'tWdgBWwThCCe7Tum',
    defaultMessage: '{seriesName} hidden',
    description:
      'Screen reader announcement when a chart legend series is hidden',
  },
  legendSeriesShownAnnouncement: {
    id: '8gqUdz9VpeEbBtre',
    defaultMessage: '{seriesName} shown',
    description:
      'Screen reader announcement when a chart legend series is shown',
  },
});
